module.exports = __webpack_public_path__ + "img/Flag_of_Slovenia.d718e9d1.svg";